export const TELEMETRY_HIDDEN_MARK = '(Secret)';
